import React from 'react'
import './_styles.scss'
import store from '../../../../../../../../../../../store'
import { MODAL_MATCH_DETAIL, showModal } from '../../../../../../../../../../../actions/modal'

function Proximo (props) {
  var homeTeam = props.homeTeam || {}
  var awayTeam = props.awayTeam || {}

  const openDetailMatch = (e) => {
    e.preventDefault()
    const { dateTime, id} = props

    const modalProps = {
      matchData: {
        matchId: id
      }
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps
    }))
  }

  return (
    <a className='mc-px match-card focusable' tabIndex={0} onClick={openDetailMatch}>
      <div className='mc-cd__band'>
        <div className='mc-cd__band mc-cd__band--home' style={{ background: homeTeam.color }} />
        <div className='mc-cd__band mc-cd__band--away' style={{ background: awayTeam.color }} />
      </div>

      <p className='mc-px__datetime'>{props.dateTime}</p>

      <p className='mc-px__comp-name'>{props.competition}</p>
      <p className='mc-px__comp-group'>{props.competitionGroup}</p>

      <div className='mc-px__sep' />

      <div className='mc-px__flag mc-px__flag--home'>
        <img src={homeTeam.flagUrl} alt={homeTeam.name} />
      </div>
      <p className='mc-px__team-name mc-px__team-name--home'>{homeTeam.name}</p>
      <p className='mc-px__score mc-px__score--home'>-</p>

      <div className='mc-px__flag mc-px__flag--away'>
        <img src={awayTeam.flagUrl} alt={awayTeam.name} />
      </div>
      <p className='mc-px__team-name mc-px__team-name--away'>{awayTeam.name}</p>
      <p className='mc-px__score mc-px__score--away'>-</p>
    </a>
  )
}

export default Proximo



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard/Components/Proximo/index.jsx